import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { PSG_ARCHETYPE_ERRORS } from '../utility/constants';
import { ErrorDialogComponent } from '../../shared/error-dialog/error-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class PubsubService {
  constructor(  private dialog: MatDialog,
    public dialogRef: MatDialogRef<ErrorDialogComponent>,) {}

  private toggelObs$: BehaviorSubject<any> = new BehaviorSubject(false);
  private scopeGenerator$: BehaviorSubject<any> = new BehaviorSubject(false);
  private stepper$: BehaviorSubject<any> = new BehaviorSubject(false);
  private enableScopeGenerator$: BehaviorSubject<any> = new BehaviorSubject(false);
  private enableScopeGeneratornew$: BehaviorSubject<any> = new BehaviorSubject(false);
  private enableDownloadbutton$: BehaviorSubject<any> = new BehaviorSubject(false);
  private subPhaseAdded$: BehaviorSubject<any> = new BehaviorSubject(false);
  private packagePrefData$: BehaviorSubject<any> = new BehaviorSubject([]);
  private scopeGenerated$: BehaviorSubject<any> = new BehaviorSubject(false);
  private stepDetails$ : Subject<any> = new Subject();
  private latestIteration$: BehaviorSubject<string> = new BehaviorSubject("");
  public psgProjectMenu: BehaviorSubject<any> = new BehaviorSubject(null);
  private taxonomyStatusReady$: BehaviorSubject<boolean> = new BehaviorSubject(false);


  getStepDetails(): Observable<any> {
    return this.stepDetails$.asObservable();
  }

  setStepDetails(data) {
    this.stepDetails$.next(data);
  }

  getToggelObs(): Observable<any> {
    return this.toggelObs$.asObservable();
  }

  setToggelObs(flag: boolean) {
    this.toggelObs$.next(flag);
  }

  scopeGeneratorSub(): Observable<any> {
    return this.scopeGenerator$.asObservable();
  }

  scopeGeneratorPub(flag) {
    this.scopeGenerator$.next(flag);
  }

  showMissingArchetypeError(err) {
    if(err?.status === PSG_ARCHETYPE_ERRORS.MISSING_ARCHETYPE) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = "38rem";
      dialogConfig.height = "16rem";
      dialogConfig.data = {
        title: "Error",
        description: err?.error,
        primarybutton: "Close",
      };
      const dialogRef = this.dialog.open(ErrorDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((result) => {
        if (result === "close") {
          this.dialogRef.close();
        }
      })
      return;
    }
  }
  // getStepper(): Observable<any> {
  //   return this.stepper$.asObservable();
  // }

  // setStepper(flag: boolean) {
  //   this.stepper$.next(flag);
  // }

  getenableScopeGenerator(): Observable<any> {
    return this.enableScopeGenerator$.asObservable();
  }

  setenableScopeGenerator(flag: boolean) {
    this.enableScopeGenerator$.next(flag);
  }
  // getenableScopeGeneratornew(): Observable<any> {
  //   return this.enableScopeGeneratornew$.asObservable();
  // }
  // setenableScopeGeneratornew(flag: boolean) {
  //   this.enableScopeGeneratornew$.next(flag);
  // }

  enableDownloadbutton(): Observable<any> {
    return this.enableDownloadbutton$.asObservable();
  }

  setDownloadbutton(flag: boolean) {
    this.enableDownloadbutton$.next(flag);
  }

  getSubPhaseData(): Observable<any> {
    return this.subPhaseAdded$.asObservable();
  }

  setSubPhaseData(flag: boolean) {
    this.subPhaseAdded$.next(flag);
  }

  getPackagePrefSub(): Observable<any> {
    return this.packagePrefData$.asObservable();
  }

  setPackagePrefSub(data: any) {
    this.packagePrefData$.next(data);
  }

  getScopeGenerated(): Observable<any> {
    return this.scopeGenerated$.asObservable();
  }

  setScopeGenerated(status) {
    this.scopeGenerated$.next(status);
  }

  getLatestIterationData(): Observable<any> {
    return this.latestIteration$.asObservable();
  }

  setLatestIterationData(flag: string) {
    this.latestIteration$.next(flag);
  }

  public setPsgProjectMenu(data) {
    this.psgProjectMenu.next(data);
  }

  public getPsgProjectMenu(): Observable<any> {
    return this.psgProjectMenu.asObservable();
  }

  getTaxonomyStatusReady(): Observable<boolean> {
    return this.taxonomyStatusReady$.asObservable();
  }

  setTaxonomyStatusReady(status: boolean) {
    this.taxonomyStatusReady$.next(status);
  }
}
